export default function Reaction1({
  size,
  color,
  className = "",
  onClick = () => {},
  active = false,
}) {
  return (
    <svg
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "0.5s",
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        backgroundColor: active ? "#eb831d" : "#ffffff",
        borderRadius: "50%",
      }}
      fill={active ? "#ffffff" : color}
      className={className}
      viewBox="0 0 64 64"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
    >
      <path
        stroke={active ? "#eb831d" : color}
        strokeWidth="1"
        d="M32,3c16,0,29,13,29,29S48,61,32,61S3,48,3,32S16,3,32,3 M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32
			s32-14.3,32-32S49.7,0,32,0L32,0z"
      />

      <circle
        stroke={active ? "#eb831d" : color}
        strokeWidth="1"
        cx="21.6"
        cy="23.3"
        r="5.7"
      />

      <circle
        stroke={active ? "#eb831d" : color}
        strokeWidth="1"
        cx="42.4"
        cy="23.3"
        r="5.7"
      />

      <path
        stroke={active ? "#eb831d" : color}
        strokeWidth="1"
        d="M22.5,46.5c1.4-3.8,5.1-6.5,9.4-6.5c4.4,0,8.1,2.8,9.5,6.8"
      />
    </svg>
  );
}
